import { z } from 'zod';
// ─── Timeline Validation ────────────────────────────────────────────────────
export const createTimelineEntrySchema = z.object({
    time: z.string().max(50).optional(),
    title: z.string().min(1).max(500),
    location: z.string().max(500).optional(),
    vendorId: z.string().uuid().optional(),
    vendorNote: z.string().max(500).optional(),
    notes: z.string().max(2000).optional(),
    sortOrder: z.number().int().optional(),
});
export const updateTimelineEntrySchema = z.object({
    time: z.string().max(50).nullable().optional(),
    title: z.string().min(1).max(500).optional(),
    location: z.string().max(500).nullable().optional(),
    vendorId: z.string().uuid().nullable().optional(),
    vendorNote: z.string().max(500).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    sortOrder: z.number().int().optional(),
});
export const createTimelineSectionSchema = z.object({
    name: z.string().min(1).max(255),
    nameHe: z.string().max(255).optional(),
    sortOrder: z.number().int().optional(),
    entries: z.array(createTimelineEntrySchema).optional(),
});
export const updateTimelineSectionSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    nameHe: z.string().max(255).nullable().optional(),
    sortOrder: z.number().int().optional(),
});
export const createTimelineSchema = z.object({
    eventId: z.string().uuid().optional(),
    isTemplate: z.boolean().optional(),
    templateName: z.string().max(255).optional(),
    title: z.string().max(500).optional(),
    description: z.string().max(2000).optional(),
    rainPlanNotes: z.string().max(2000).optional(),
    eventDate: z.string().datetime().optional(),
    eventTypeId: z.string().uuid().nullable().optional(),
    sections: z.array(createTimelineSectionSchema).optional(),
});
export const updateTimelineSchema = z.object({
    title: z.string().max(500).nullable().optional(),
    templateName: z.string().max(255).nullable().optional(),
    description: z.string().max(2000).nullable().optional(),
    rainPlanNotes: z.string().max(2000).nullable().optional(),
    eventDate: z.string().datetime().nullable().optional(),
    eventTypeId: z.string().uuid().nullable().optional(),
});
// ─── Checklist Validation ───────────────────────────────────────────────────
export const createChecklistItemSchema = z.object({
    title: z.string().min(1).max(500),
    assignee: z.string().max(255).optional(),
    isDone: z.boolean().optional(),
    status: z.enum(['TODO', 'IN_PROGRESS', 'DONE', 'BLOCKED']).optional(),
    dueDate: z.string().optional(),
    assignedToUserId: z.string().uuid().optional(),
    notes: z.string().max(2000).optional(),
    sortOrder: z.number().int().optional(),
    dueDateOffsetDays: z.number().int().nullable().optional(),
});
export const updateChecklistItemSchema = z.object({
    title: z.string().min(1).max(500).optional(),
    assignee: z.string().max(255).nullable().optional(),
    isDone: z.boolean().optional(),
    status: z.enum(['TODO', 'IN_PROGRESS', 'DONE', 'BLOCKED']).optional(),
    dueDate: z.string().nullable().optional(),
    assignedToUserId: z.string().uuid().nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    sortOrder: z.number().int().optional(),
    dueDateOffsetDays: z.number().int().nullable().optional(),
});
export const createChecklistSectionSchema = z.object({
    name: z.string().min(1).max(255),
    nameHe: z.string().max(255).optional(),
    sortOrder: z.number().int().optional(),
    items: z.array(createChecklistItemSchema).optional(),
});
export const updateChecklistSectionSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    nameHe: z.string().max(255).nullable().optional(),
    sortOrder: z.number().int().optional(),
});
export const createChecklistSchema = z.object({
    eventId: z.string().uuid().optional(),
    isTemplate: z.boolean().optional(),
    templateName: z.string().max(255).optional(),
    title: z.string().max(500).optional(),
    description: z.string().max(2000).optional(),
    sections: z.array(createChecklistSectionSchema).optional(),
});
export const updateChecklistSchema = z.object({
    title: z.string().max(500).optional(),
    description: z.string().max(2000).nullable().optional(),
});
export const toggleChecklistItemSchema = z.object({
    isDone: z.boolean(),
});
// ─── Kibuddim Validation ───────────────────────────────────────────────────
export const createKibuddimRoleSchema = z.object({
    roleName: z.string().min(1).max(500),
    roleNameEn: z.string().max(500).optional(),
    assignee: z.string().max(255).optional(),
    notes: z.string().max(2000).optional(),
    sortOrder: z.number().int().optional(),
});
export const updateKibuddimRoleSchema = z.object({
    roleName: z.string().min(1).max(500).optional(),
    roleNameEn: z.string().max(500).nullable().optional(),
    assignee: z.string().max(255).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    sortOrder: z.number().int().optional(),
});
export const createKibuddimSectionSchema = z.object({
    name: z.string().min(1).max(255),
    nameHe: z.string().max(255).optional(),
    sortOrder: z.number().int().optional(),
    roles: z.array(createKibuddimRoleSchema).optional(),
});
export const updateKibuddimSectionSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    nameHe: z.string().max(255).nullable().optional(),
    sortOrder: z.number().int().optional(),
});
export const createKibuddimSchema = z.object({
    eventId: z.string().uuid().optional(),
    isTemplate: z.boolean().optional(),
    templateName: z.string().max(255).optional(),
    title: z.string().max(500).optional(),
    description: z.string().max(2000).optional(),
    sections: z.array(createKibuddimSectionSchema).optional(),
});
export const updateKibuddimSchema = z.object({
    title: z.string().max(500).optional(),
    description: z.string().max(2000).nullable().optional(),
});
//# sourceMappingURL=event-ops.js.map